import type { GetUserSessionsRequest } from '@gdladder/shared/features';
import APIClient from '../../../../api/APIClient';

export async function getUserSessions() {
    const res = await APIClient.get<GetUserSessionsRequest>('/sessions');
    return res.data.data;
}
